module.exports = __webpack_public_path__ + "img/polygon.26aaea42.svg";